import AppsRoundedIcon from '@mui/icons-material/AppsRounded';
import CelebrationRoundedIcon from '@mui/icons-material/CelebrationRounded';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import CloudRoundedIcon from '@mui/icons-material/CloudRounded';
import DirectionsCarRoundedIcon from '@mui/icons-material/DirectionsCarRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import MailRoundedIcon from '@mui/icons-material/MailRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import NewspaperRoundedIcon from '@mui/icons-material/NewspaperRounded';
import RestaurantRoundedIcon from '@mui/icons-material/RestaurantRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import SportsScoreRoundedIcon from '@mui/icons-material/SportsScoreRounded';
import TempleBuddhistRoundedIcon from '@mui/icons-material/TempleBuddhistRounded';
import TrainRoundedIcon from '@mui/icons-material/TrainRounded';
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';

const TOPIC_ICON_RULES = [
  { keywords: ['sant', 'gesund', 'med', 'arzt', 'doctor', 'soin', 'pflege'], icon: HealthAndSafetyRoundedIcon },
  { keywords: ['voyage', 'reise', 'urlaub', 'vacance', 'ferien', 'trip'], icon: DirectionsCarRoundedIcon },
  { keywords: ['vetement', 'kleid', 'kleidung', 'habit', 'mode', 'shirt'], icon: CheckroomIcon },
  { keywords: ['enfant', 'kind', 'kinder', 'baby', 'bebe'], icon: ChildFriendlyIcon },
  { keywords: ['post', 'lettre', 'brief', 'courrier', 'mail'], icon: MailRoundedIcon },
  { keywords: ['logement', 'wohnen', 'wohnung', 'maison', 'haus', 'home'], icon: HomeRoundedIcon },
  { keywords: ['travail', 'arbeit', 'job', 'work', 'emploi', 'beruf'], icon: WorkRoundedIcon },
  { keywords: ['transport', 'mobilit', 'verkehr', 'bus', 'train', 'tram', 'travel'], icon: TrainRoundedIcon },
  { keywords: ['achat', 'einkauf', 'shop', 'kauf', 'magasin', 'course'], icon: ShoppingCartRoundedIcon },
  { keywords: ['culture', 'schweiz', 'suisse', 'tradition', 'relig', 'geschichte'], icon: TempleBuddhistRoundedIcon },
  {
    keywords: ['nourriture', 'essen', 'repas', 'food', 'restaurant', 'cuisine', 'manger'],
    icon: RestaurantRoundedIcon,
  },
  { keywords: ['meteo', 'wetter', 'weather', 'klima'], icon: CloudRoundedIcon },
  { keywords: ['fete', 'fest', 'party', 'anniversaire', 'feier'], icon: CelebrationRoundedIcon },
  {
    keywords: ['medias', 'medien', 'loisirs', 'media', 'freizeit', 'tv', 'radio'],
    icon: NewspaperRoundedIcon,
  },
  {
    keywords: ['administration', 'admin', 'office', 'bureau', 'document', 'papier', 'formular', 'brief'],
    icon: AppsRoundedIcon,
  },
  { keywords: ['ecole', 'schule', 'cours', 'lernen', 'study', 'bildung', 'exam'], icon: SchoolRoundedIcon },
  { keywords: ['sport', 'match', 'football', 'fussball', 'jeu'], icon: SportsScoreRoundedIcon },
  { keywords: ['famille', 'famil', 'community', 'communaut', 'social'], icon: GroupsRoundedIcon },
];

const stripDiacritics = (value = '') => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export function resolveTopicIcon(title) {
  const normalized = stripDiacritics((title || '').toLowerCase());
  const match = TOPIC_ICON_RULES.find(({ keywords }) => keywords.some((keyword) => normalized.includes(keyword)));
  return match?.icon || MenuBookRoundedIcon;
}
